export enum OrderDirection {
  Ascending = 'ascending',
  Descending = 'descending',
}
